import React from "react";
import { Link, useHistory } from "react-router-dom";
import { updateCandidateQualification } from "../../../../APIs/PostAPIS";
import { MainContext } from "../../../Dashboard/DashboardContext/Context";
import Notification from "../../../Portals/Notification/Notification";
import "./qualification.style.scss";
import QualificationForm from "./QualificationForm/QualificationForm";
export default function QualificationComponent({
  changeRoute,
  currentRoute,
  setNotification,
  completeIt,
}) {
  const context = React.useContext(MainContext);
  const { userDetails, initialChecking, updateState, registrationStep } =
    context;
  const history = useHistory();
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [qualificationData, setQualificationData] = React.useState([
    { ...schema },
  ]);
  const handleDelete = (num) => {
    qualificationData.splice(num, 1);
    setQualificationData([...qualificationData]);
  };
  const handleChanges = (obj, num) => {
    qualificationData[num] = { ...obj };
    setQualificationData([...qualificationData]);
  };
  const handleSkip = () => {
    let temp = [...registrationStep];
    temp[1] = { ...temp[1], skipped: true };
    updateState("registrationStep", [...temp]);
    changeRoute();
    history.push("/register/employment");
  };
  const clearNotification = () => {
    history.push("/register/employment");
    let a = setTimeout(() => {
      setNotification({
        status: false,
        title: "",
        moreDetails: "",
      });
      changeRoute();
      setLoading(false);
      clearTimeout(a);
    }, [3000]);
  };
  const handleUpdate = async () => {
    let temp = qualificationData.map((obj) => {
      if (!obj.others.length) {
        return {
          qualification: obj.qualification,
          specialization: obj.specialization,
          college: obj.college,
          university: obj.university,
          passing_year: obj.passing_year,
          course_type: obj.course_type,
        };
      } else {
        let insideTemp = obj;
        obj.others.forEach((x) => {
          if (x === "q") {
            insideTemp = {
              ...insideTemp,
              qualification: insideTemp.other_qualification._id,
            };
          }
          if (x === "s") {
            insideTemp = {
              ...insideTemp,
              specialization: insideTemp.other_specialization._id,
            };
          }
          if (x === "u") {
            insideTemp = {
              ...insideTemp,
              university: insideTemp.other_university._id,
            };
          }
          if (x === "c") {
            insideTemp = {
              ...insideTemp,
              college: insideTemp.other_college._id,
            };
          }
        });
        return {
          qualification: insideTemp.qualification,
          specialization: insideTemp.specialization,
          college: insideTemp.college,
          university: insideTemp.university,
          passing_year: insideTemp.passing_year,
          course_type: insideTemp.course_type,
        };
      }
    });
    let tempLast = {
      candidate_qualification: [...temp],
    };

    setLoading(true);
    try {
      let res = await updateCandidateQualification({ ...tempLast });
      if (!res.data.error) {
        completeIt();
        setNotification({
          status: true,
          title: `Qualification Details Updated`,
          moreDetails: ``,
        });
        initialChecking();
        clearNotification();
      } else {
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const testLastOne = () => {
    let temp = qualificationData[qualificationData.length - 1];
    let check =
      !temp.qualification ||
      !temp.specialization ||
      !temp.university ||
      !temp.college ||
      !temp.passing_year ||
      !temp.course_type ||
      (temp.qualification === "other" && !temp.other_qualification._id) ||
      (temp.specialization === "other" && !temp.other_specialization._id) ||
      (temp.university === "other" && !temp.university._id) ||
      (temp.college === "other" && !temp.college._id);

    setError(check);
    return check;
  };
  React.useEffect(() => {
    currentRoute();
  }, []);
  React.useEffect(() => {
    if (!userDetails?.candidate_qualification?.length) {
      setQualificationData([{ ...schema }]);
    } else {
      let temp = userDetails.candidate_qualification.map((x) => {
        return { ...schema, ...x };
      });
      setQualificationData([...temp]);
    }
  }, []);
  return (
    <form
      onSubmit={(e) => e.preventDefault()}
      className="qualification-component"
    >
      <header className="qc-header">
        <p>Step 2. Qualification</p>
      </header>
      <div className="qc-body">
        {qualificationData.map((obj, num) => (
          <QualificationForm
            error={error}
            current={num === qualificationData.length - 1}
            handleChanges={handleChanges}
            data={obj}
            num={num}
            handleDelete={(num) => handleDelete(num)}
          />
        ))}
      </div>
      <div className="add-new">
        <p
          onClick={() =>
            testLastOne()
              ? console.log()
              : setQualificationData([...qualificationData, schema])
          }
        >
          + Add Qualification
        </p>
      </div>
      <div className="qc-footer">
        <button onClick={() => handleSkip()}>Skip Step</button>
        <button
          type="submit"
          disabled={loading}
          onClick={() => (testLastOne() ? console.log() : handleUpdate())}
        >
          {loading ? "Updating...." : "Update"}
        </button>
      </div>
    </form>
  );
}
const schema = {
  qualification: "",
  others: [],
  other_qualification: {
    _id: "",
    name: "",
  },
  specialization: "",
  other_specialization: {
    _id: "",
    name: "",
  },
  university: "",
  other_university: {
    _id: "",
    name: "",
  },
  college: "",
  other_college: {
    _id: "",
    name: "",
  },
  passing_year: "",
  course_type: "",
};
